<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="0" />
    <div v-else>
      <LmBreadcrumb v-if="showBreadcrumb"/>
      <form
        @submit.prevent="submit"
        novalidate
        class="position-relative">
        <component
          v-for="(field, index) in formFields"
          :key="index"
          :is="field.component"
          v-model="form[field.name]"
          :options="field.options"
          :v="$v.form[field.name]"
          :label="field.label"
          :placeholder="field.placeHolder"
          :readonly="field.readonly"
        />
        <LmButton
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="submit"
          buttonClass="btn-primary"
          :isProcessing="formIsProcessing"
          :value="$t('Save')"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
        <LmButton
          v-if="!enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('Cancel')"
          @click.native="cancelBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
          <LmComponentLoading v-if="loading" />
      </form>
      <!-- <b-modal
        id="confirmModal"
        ref="confirmModal"
        :title="$t('Are you sure?')"
        title-tag="h3"
        :cancel-title="$t('Cancel')"
        :ok-title="$t('Ok')"
        centered
        lazy
        @ok="confirmModalOk"
        >
        <p>{{$t('sure_leave_page_coupon')}}</p>
      </b-modal> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'
import resetForm from '@/helpers/form.js'

export default {
  components: {
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      form: {},
      formFields: [],
      formIsProcessing: false
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail', 'loading']),
    ...mapState('commons', ['loading']),
    apiCall () {
      return {
        path: this.newOrEditEndpointUri,
        id: this.isOnEditMode ? this.$route.params.id : null
      }
    }
  },
  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  validations () {
    // Las validaciones ocurren al submitear por lo que se asume que para
    // ese momento la API de settings ya tendría que haber retornado los
    // parametros de validacion
    let formValidations = {
      form: {}
    }
    // Se construye la lista de validaciones de manera dinamica en base a lo existente en
    // this.formFields
    this.formFields.forEach(field => {
      if (field.validation === 'required') {
        formValidations.form[field.name] = { required }
      } else {
        formValidations.form[field.name] = {}
      }
    })
    return formValidations
  },
  methods: {
    ...mapActions('commons', ['getItemDetail', 'updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    goBackBtn () {
      this.$router.push(this.onSuccessDestinationRoute)
    },
    cancelBtn () {
      if (this.$v.form.$invalid) {
        this.$router.push(this.onSuccessDestinationRoute)
      } else {
        if (confirm(this.$t('cancel_msg'))) {
          this.$router.push(this.onSuccessDestinationRoute)
        }
      }
    },
    submit () {
      this.$v.form.$touch()
      if (!this.$v.form.$pending && !this.$v.form.$error) {
        this.formIsProcessing = true
        /**
         * Se persisten los datos
         */
        let data = this.form
        data.id = this.$route.params.id
        this.updateItemDetail({
          'path': this.newOrEditEndpointUri,
          'data': data
        })
          .then(() => {
            this.formIsProcessing = false
            this.$router.push(this.onSuccessDestinationRoute)
          })
          .catch(e => {
            this.formIsProcessing = false
            alert(this.$t('try_again_later'))
          })
      }
    }
  },
  created () {
    /**
     * Se obtiene la parametrizacion detallada para poder mostrar el
     * la vista
     * TODO:
     * - [ ] : Manejar errores, cuyo default sea no romper la app y volver al home
     *         enviando el error a rollbar
     */
    const fetchAddOrEditSettings = async () => {
      const d = await this.geAddOrEditSettings(this.newOrEditEndpointUri)
      if (d) {
        this.formFields = d.formFields
        let form = {}
        this.formFields.map(field => {
          form[field.name] = null
        })
        this.form = form
      }
    }
    // Se obtiene settings desde el endpoint de configuracion
    fetchAddOrEditSettings()
      .then(() => {
        // Una vez que se obtuvieron los settings se procede a obtener el detalle
        // del beneficio si se está en en modo edicion es decir si isOnEditMode === true
        if (this.isOnEditMode) {
          // Si se está en modo edición es necesario asignar a los
          // campos del formulario su valor actual.
          const fetchItemDetailsAsync = async () => {
            await this.getItemDetail(this.apiCall)
            this.formFields.forEach((formField, i) => {
              if (this.itemDetail.hasOwnProperty(formField.name)) {
                this.form[formField.name] = this.itemDetail[formField.name]
              }
            })
          }
          fetchItemDetailsAsync()
        }
      })
  },
  beforeRouteLeave (to, from, next) {
    if (this.$v.$anyError) {
      if (confirm(this.$t('sure_leave_page'))) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'coupons_new') {
        resetForm(this.form)
        setTimeout(() => {
          this.$v.form.$reset()
        }, 50)
      }
    }
  }
}
</script>

/*
TODO:
  * Acordar con backend como vamos a traer los valores options de los selects. https://github.com/lumile/lumbre/issues/137#issuecomment-456820475
  * Mostrar un mensaje adecuado cuando el formulario se guard y otro cuando el formulario falla (actualmente se muestran errores indivicuales pero no el general)
  * Acordar con Backend las validaciones específica de cada input.
  * Seria bueno que la utilidad reset form puda utilizar la función $v.form.$reset() asi mejorar su reusablidad.
  * Seria bueno encontrar una forma más prolija de asignar lo valores al formulario cuando se edita. Quizás podria ayudar acordar nombres para los campos de la api y typos de datos para evitar hacer trasformaciones de tipos y mejorar el rendimiento y el mantenimiento.
  * Reemplazar el confirm por un modal
  * Resolver el hack del setTimeout y $reset
  * Encontrar la forma de reutilizar el submit
*/
